/**
 * File d’attente modales globales (priorité basse = affichée en premier).
 * Une seule modale active à la fois.
 */
export type ModalQueueId = 'onboarding' | 'chapter' | 'offline'

const queue = ref<{ id: ModalQueueId; priority: number }[]>([])
const activeId = ref<ModalQueueId | null>(null)

function sortQueue() {
  queue.value.sort((a, b) => a.priority - b.priority)
}

function activateNext() {
  if (activeId.value) return
  const next = queue.value[0]
  activeId.value = next?.id ?? null
}

export function useModalQueue() {
  function requestModal(id: ModalQueueId, priority: number) {
    if (!queue.value.some((e) => e.id === id)) {
      queue.value.push({ id, priority })
      sortQueue()
    }
    if (!activeId.value) activateNext()
  }

  function releaseModal(id: ModalQueueId) {
    queue.value = queue.value.filter((e) => e.id !== id)
    if (activeId.value === id) {
      activeId.value = null
      activateNext()
    }
  }

  function isModalActive(id: ModalQueueId): boolean {
    return activeId.value === id
  }

  function canShowModal(id: ModalQueueId): boolean {
    if (!queue.value.some((e) => e.id === id)) return false
    return activeId.value === id
  }

  return {
    activeModalId: readonly(activeId),
    requestModal,
    releaseModal,
    isModalActive,
    canShowModal,
  }
}
